export default "__VITE_ASSET__b7cfef1d__"